import { useEffect } from "react";

const SITE = "SENIORCAR";
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

/**
 * Client-side SEO head manager (title, meta, canonical, JSON-LD, robots).
 * Note: CRA renders client-side; production SEO would benefit from SSR/prerender.
 */
export default function Seo({ title, description, keywords, canonical, noindex, image, jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — La libertà di continuare a muoversi`;
    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    const canon = canonical || (ORIGIN + window.location.pathname);
    upsertLink("canonical", canon);

    const ldId = "sc-jsonld";
    document.getElementById(ldId)?.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = ldId;
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
    return () => { document.getElementById(ldId)?.remove(); };
  }, [title, description, keywords, canonical, noindex, image, jsonLd]);

  return null;
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "SENIORCAR",
  description: "Dispositivo medico per la mobilità di persone con patologie permanenti e difficoltà motorie.",
  url: ORIGIN,
};
